import { Serializable } from "../core";

export class Config implements Serializable<Config> {
  public freeDeliveryMinPrice!: number;
  public deliveryPrice!: number;
  public pageSize!: number;

  public static default(): Config {
    const config = new Config();
    config.deliveryPrice = 0;
    config.freeDeliveryMinPrice = 0;
    config.pageSize = 20;
    return config;
  }

  deserialize(json: any): Config {
    this.freeDeliveryMinPrice = json.free_delivery_min_price;
    this.deliveryPrice = json.delivery_price;
    this.pageSize = json.page_size;
    return this;
  }
}
